class AccessToken {
    constructor(accessToken, tokenType, expiresTime) {
        this.accessToken = accessToken
        this.tokenType = tokenType
        this.expiresTime = expiresTime
    }
}

export default AccessToken